import { Typography } from "@mui/material";
import { GenericInfoNotificationProps } from "./types";

export const GenericInfoNotification: React.FC<GenericInfoNotificationProps> = ({ text }: GenericInfoNotificationProps) =>
  <Typography>
    {text}
  </Typography>

